import { createActions, createReducer } from 'reduxsauce'

import ObjetoLicitacaoService from '../servicos/ObjetoLicitacaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaObjetoLicitacaoInicio: [],
    buscaObjetoLicitacaoSucesso: ['objetoLicitacao'],
    buscaObjetoLicitacaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaObjetoLicitacao = () => {
    return dispatch => {
        dispatch(Creators.buscaObjetoLicitacaoInicio())
        let serv = new ObjetoLicitacaoService()
        return serv
            .getObjetoLicitacao()
            .then(response => dispatch(Creators.buscaObjetoLicitacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaObjetoLicitacaoErro(error)))
    }
}

const buscaObjetoLicitacaoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaObjetoLicitacaoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaObjetoLicitacaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.objetoLicitacao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_OBJETO_LICITACAO_INICIO]: buscaObjetoLicitacaoInicio,
    [Types.BUSCA_OBJETO_LICITACAO_ERRO]: buscaObjetoLicitacaoErro,
    [Types.BUSCA_OBJETO_LICITACAO_SUCESSO]: buscaObjetoLicitacaoSucesso,
})
